module.exports = "/assets/data/b0060cf929fd07ae77bfc048968fd2bb-L16.data.json";